import * as yup from "yup";

export const schema = yup.object().shape({
    name: yup
        .string()
        .required()
        .min(3)
        .max(50),
    description: yup
        .string()
        .required()
        .min(3)
        .max(255),
});